import { configureStore } from '@reduxjs/toolkit';
import { rowsApi } from './queries/rows';

export const store = configureStore({
  reducer: {
    [rowsApi.reducerPath]: rowsApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rowsApi.middleware),
});
